import { BusinessObject } from './business-object.js'
import {
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
	jsonMapProperty,
} from '@sumbricht/json-class-serializer'
import { assignCommonProperties } from '../util/data/assign-common-properties.js'

@jsonClass('Language')
export class Language extends BusinessObject {
	@jsonProperty(String)
	isoCode?: string
	@jsonProperty(String)
	shortName?: string
	@jsonProperty(String)
	displayName?: string

	constructor(init?: Partial<Language>) {
		super()
		assignCommonProperties(this, init)
	}

	getClassNames(): string[] {
		return ['$T']
	}
}
